
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Quelles sont les étapes de création d’un site Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Création, mise en ligne, maintenance, vous connaîtrez l’envers du décor de la création d’un site Internet avec une agence de communication.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Quelles sont les étapes de création d’un site Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Création, mise en ligne, maintenance, vous connaîtrez l’envers du décor de la création d’un site Internet avec une agence de communication.",
        },
      ],
    };
  },
};
